import { IDataGridColumn } from '../interfaces/IDataGridColumn';

const fetchPageData = async (
  ev: React.MouseEvent<
    HTMLButtonElement | HTMLAnchorElement | HTMLSpanElement,
    MouseEvent
  >,
  columns: IDataGridColumn[],
  setSortState: (key: string | number) => void,
  updateRowsRefs: (sortedRowsCopy: any) => void,
) => {
  ev.preventDefault();
  const key = ev.currentTarget.dataset.key || '';
  const idx = columns.findIndex((c: any) => c.name === key);

  const fetchFunction = columns[idx].fetchFn;
  if (fetchFunction) {
    const name = columns[idx].name;
    setSortState(name);
    let fieldToSort = '';

    // TODO: For now, we can just sort of globally add these sort fields as
    // needed. But, we may want to eventually break these out and make them
    // feature specific and then dependency inject them into the grid (later)
    if (name === 'creationDate') {
      fieldToSort = 'createdAt';
    } else {
      fieldToSort = name;
    }

    const applications = await fetchFunction({
      pageNumber: 1,
      sortField: fieldToSort,
    });
    updateRowsRefs(applications.items);
  }
};

export default fetchPageData;
